// This file now exports a function that dynamically builds the menu
// based on the client's status.

const getGroupMenuItems = (group, t) => {
    const menu = [
        { 
            type: 'item', 
            section: 'groupAccessList', 
            text: 'group', 
            key:'i-groupAccessList' 
        },
        { 
            type: 'item', 
            section: 'billing', 
            text: 'billing', 
            key:'i-billing' 
        },
    ];

    // --- START OF FIX ---
    // Only show the "Plans" page to standard clients.
    // Special clients with custom deals should not see the standard paywall.
    const isSpecialClient = group?.trialEndDate || group?.customPriceId;

    if (!isSpecialClient) {
        menu.splice(1, 0, { // Insert "Plans" item after "Group"
            type: 'item', 
            section: 'plans', 
            text: 'plans', 
            key:'i-plans' 
        });
    }
    
    // The invite button can stay for everyone.
    menu.push({ 
        type: 'item', 
        section: 'createGroupAccess', 
        text: 'create', 
        key:'i-createGroupAccess' 
    });
    // --- END OF FIX ---

    return menu;
};

export default getGroupMenuItems;